export const environment = {
  production: false,
  env: 'apache',

  //Apache:
  routeTo:'/edonacije',
  API_URL: `${window.location.origin}/edonacijeweb-back/`,



};
